module.exports = __webpack_public_path__ + "VIPV24.png?4e9d192a17e9b152cf22e7cd43eb9644";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV24.png
// module id = 119
// module chunks = 0